//eslint-disable-next-line
export default [
	{
		id: 0,
		name: '1-Aminonaphthalene',
		reduction_percent: '99.9',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '21.6',
		tabacco_percent: '0.027',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 1,
		name: '1,3-Butadiene',
		reduction_percent: '99.9',
		reduction_quantity: '1',
		cigarette_percent: '98.5',
		tabacco_percent: '0.14',
		unit: 'μg',
	},
	{
		id: 2,
		name: '2-Aminonaphthalene',
		reduction_percent: '99.9',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '16.2',
		tabacco_percent: '0.012',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 3,
		name: '3-Aminobiphenyl',
		reduction_percent: '99.9',
		reduction_quantity: '1',
		cigarette_percent: '4.18',
		tabacco_percent: '0.0041',
		unit: 'ng',
	},
	{
		id: 4,
		name: '4-Aminobiphenyl',
		reduction_percent: '99.8',
		reduction_quantity: '1',
		cigarette_percent: '2.83',
		tabacco_percent: '0.0053',
		unit: 'ng',
	},
	{
		id: 5,
		name: 'NNK',
		sub_title: '4-(Methyl-nitrosamino)-1- <br/> (3-pyridyl)-1-butanone',
		reduction_percent: '96.6',
		reduction_quantity: '3',
		cigarette_percent: '264',
		tabacco_percent: '8.95',
		unit: 'ng',
	},
	{
		id: 6,
		name: 'Acetaldehyde',
		reduction_percent: '90.4',
		reduction_quantity: '10',
		cigarette_percent: '1,641',
		tabacco_percent: '158',
		unit: 'μg',
	},
	{
		id: 7,
		name: 'Acetamide',
		reduction_percent: '84.2',
		reduction_quantity: '16',
		cigarette_percent: '12.9',
		tabacco_percent: '2.04',
		unit: 'μg',
	},
	{
		id: 8,
		name: 'Acetone',
		reduction_percent: '96.3',
		reduction_quantity: '4',
		cigarette_percent: '690',
		tabacco_percent: '25.4',
		unit: 'μg',
	},
	{
		id: 9,
		name: 'Acrolein',
		reduction_percent: '94.9',
		reduction_quantity: '5',
		cigarette_percent: '156',
		tabacco_percent: '7.95',
		unit: 'μg',
	},
	{
		id: 10,
		name: 'Acrylamide',
		reduction_percent: '82.7',
		reduction_quantity: '17',
		cigarette_percent: '4.46',
		tabacco_percent: '0.773',
		unit: 'μg',
	},
	{
		id: 11,
		name: 'Acrylonitrile',
		reduction_percent: '99.6',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '24.5',
		tabacco_percent: '0.107',
		unit: 'μg',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 12,
		name: 'Ammonia',
		reduction_percent: '65.9',
		reduction_quantity: '34',
		cigarette_percent: '29.3',
		tabacco_percent: '10',
		unit: 'μg',
	},
	{
		id: 13,
		name: 'Arsenic',
		reduction_percent: '90.5',
		percentage_text: 'more than',
		reduction_quantity: '9',
		cigarette_percent: '7.9',
		tabacco_percent: '0.75',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 14,
		name: 'Benz[a]anthracene',
		reduction_percent: '95.3',
		reduction_quantity: '5',
		cigarette_percent: '27.1',
		tabacco_percent: '1.28',
		unit: 'ng',
	},
	{
		id: 15,
		name: 'Benzene',
		reduction_percent: '99.6',
		reduction_quantity: '1',
		cigarette_percent: '81.1',
		tabacco_percent: '0.348',
		unit: 'μg',
	},
	{
		id: 16,
		name: 'Benzo[a]pyrene',
		reduction_percent: '96.0',
		reduction_quantity: '4',
		cigarette_percent: '15',
		tabacco_percent: '0.6',
		unit: 'ng',
	},
	{
		id: 17,
		name: 'Butyraldehyde',
		reduction_percent: '83.1',
		reduction_quantity: '17',
		cigarette_percent: '83.5',
		tabacco_percent: '14.1',
		unit: 'μg',
	},
	{
		id: 18,
		name: 'Cadmium',
		reduction_percent: '99.9',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '92.9',
		tabacco_percent: '0.075',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 19,
		name: 'Carbon monoxide',
		reduction_percent: '98.9',
		reduction_quantity: '1',
		cigarette_percent: '30.2',
		tabacco_percent: '0.324',
		unit: 'mg',
	},
	{
		id: 20,
		name: 'Catechol',
		reduction_percent: '90.6',
		reduction_quantity: '9',
		cigarette_percent: '89.8',
		tabacco_percent: '8.44',
		unit: 'μg',
	},
	{
		id: 21,
		name: 'Chromium',
		reduction_percent: '77.3',
		percentage_text: 'more than',
		reduction_quantity: '23',
		cigarette_percent: '11',
		tabacco_percent: '2.5',
		unit: 'ng',
		less_than_tabacco: true,
		less_than_cigarette: true,
		has_additional_info: true,
	},
	{
		id: 22,
		name: 'Crotonaldehyde',
		reduction_percent: '93.5',
		percentage_text: 'more than',
		reduction_quantity: '7',
		cigarette_percent: '50.5',
		tabacco_percent: '3.29',
		unit: 'μg',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 23,
		name: 'Dibenz[a,h]anthracene',
		reduction_percent: '85.5',
		percentage_text: 'more than',
		reduction_quantity: '15',
		cigarette_percent: '0.853',
		tabacco_percent: '0.124',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 24,
		name: 'Ethylene oxide',
		reduction_percent: '99.3',
		reduction_quantity: '1',
		cigarette_percent: '22.7',
		tabacco_percent: '0.165',
		unit: 'μg',
	},
	{
		id: 25,
		name: 'Formaldehyde',
		reduction_percent: '89.4',
		reduction_quantity: '11',
		cigarette_percent: '85.2',
		tabacco_percent: '9.03',
		unit: 'μg',
	},
	{
		id: 26,
		name: 'Hydrogen cyanide',
		reduction_percent: '99.3',
		reduction_quantity: '1',
		cigarette_percent: '365',
		tabacco_percent: '2.62',
		unit: 'μg',
	},
	{
		id: 27,
		name: 'Hydroquinone',
		reduction_percent: '93.8',
		reduction_quantity: '6',
		cigarette_percent: '89.1',
		tabacco_percent: '5.5',
		unit: 'μg',
	},
	{
		id: 28,
		name: 'Isoprene',
		reduction_percent: '99.8',
		reduction_quantity: '1',
		cigarette_percent: '894',
		tabacco_percent: '1.54',
		unit: 'μg',
	},
	{
		id: 29,
		name: 'Lead',
		reduction_percent: '98.4',
		percentage_text: 'more than',
		reduction_quantity: '2',
		cigarette_percent: '32.1',
		tabacco_percent: '0.5',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 30,
		name: 'm-Cresol',
		reduction_percent: '99.4',
		reduction_quantity: '1',
		cigarette_percent: '3.51',
		tabacco_percent: '0.0198',
		unit: 'μg',
	},
	{
		id: 31,
		name: 'Mercury',
		reduction_percent: '66.0',
		reduction_quantity: '34',
		cigarette_percent: '4.77',
		tabacco_percent: '1.62',
		unit: 'ng',
	},
	{
		id: 32,
		name: 'MEK',
		sub_title: 'Methyl-ethyl-ketone',
		reduction_percent: '97.1',
		reduction_quantity: '3',
		cigarette_percent: '185',
		tabacco_percent: '5.42',
		unit: 'μg',
	},
	{
		id: 33,
		name: 'NAB',
		sub_title: 'N-nitrosoanabasine',
		reduction_percent: '91.5',
		reduction_quantity: '9',
		cigarette_percent: '30.2',
		tabacco_percent: '2.57',
		unit: 'ng',
	},
	{
		id: 34,
		name: 'NAT',
		sub_title: 'N-nitrosoanatabine',
		reduction_percent: '93.3',
		reduction_quantity: '7',
		cigarette_percent: '270',
		tabacco_percent: '18.2',
		unit: 'ng',
	},
	{
		id: 35,
		name: 'NNN',
		sub_title: 'N-Nitrosonornicotine',
		reduction_percent: '96.3',
		reduction_quantity: '4',
		cigarette_percent: '283',
		tabacco_percent: '10.6',
		unit: 'ng',
	},
	{
		id: 36,
		name: 'Nickel',
		reduction_percent: '68.6',
		percentage_text: 'more than',
		reduction_quantity: '31',
		cigarette_percent: '15.9',
		tabacco_percent: '5',
		unit: 'ng',
		less_than_tabacco: true,
		less_than_cigarette: true,
		has_additional_info: true,
	},
	{
		id: 37,
		name: 'Nitric oxide (NO)',
		reduction_percent: '98.2',
		reduction_quantity: '2',
		cigarette_percent: '504',
		tabacco_percent: '8.95',
		unit: 'μg',
	},
	{
		id: 38,
		name: 'Nitro benzene',
		reduction_percent: '71.1',
		percentage_text: 'more than',
		reduction_quantity: '29',
		cigarette_percent: '0.038',
		tabacco_percent: '0.011',
		unit: 'μg',
		less_than_tabacco: true,
		less_than_cigarette: true,
		has_additional_info: true,
	},
	{
		id: 39,
		name: 'Nitrogen oxides (NOx)',
		reduction_percent: '98.2',
		reduction_quantity: '2',
		cigarette_percent: '560',
		tabacco_percent: '9.8',
		unit: 'μg',
	},
	{
		id: 40,
		name: 'o-Cresol',
		reduction_percent: '98.9',
		reduction_quantity: '1',
		cigarette_percent: '4.15',
		tabacco_percent: '0.0476',
		unit: 'μg',
	},
	{
		id: 41,
		name: 'o-Toluidine',
		reduction_percent: '99.2',
		reduction_quantity: '1',
		cigarette_percent: '105',
		tabacco_percent: '0.887',
		unit: 'ng',
	},
	{
		id: 42,
		name: 'p-Cresol',
		reduction_percent: '99.5',
		reduction_quantity: '1',
		cigarette_percent: '8.63',
		tabacco_percent: '0.0454',
		unit: 'μg',
	},
	{
		id: 43,
		name: 'Phenol',
		reduction_percent: '92.9',
		reduction_quantity: '7',
		cigarette_percent: '14',
		tabacco_percent: '0.989',
		unit: 'μg',
	},
	{
		id: 44,
		name: 'Propionaldehyde',
		reduction_percent: '92.8',
		reduction_quantity: '7',
		cigarette_percent: '123',
		tabacco_percent: '8.83',
		unit: 'μg',
	},
	{
		id: 45,
		name: 'Propylene oxide',
		reduction_percent: '88.9',
		reduction_quantity: '11',
		cigarette_percent: '1,103',
		tabacco_percent: '122',
		unit: 'ng',
	},
	{
		id: 46,
		name: 'Pyrene',
		reduction_percent: '93.6',
		reduction_quantity: '6',
		cigarette_percent: '81.8',
		tabacco_percent: '5.26',
		unit: 'ng',
	},
	{
		id: 47,
		name: 'Pyridine',
		reduction_percent: '83.9',
		reduction_quantity: '16',
		cigarette_percent: '29.7',
		tabacco_percent: '4.77',
		unit: 'μg',
	},
	{
		id: 48,
		name: 'Quinoline',
		reduction_percent: '97.4',
		percentage_text: 'more than',
		reduction_quantity: '3',
		cigarette_percent: '0.431',
		tabacco_percent: '0.011',
		unit: 'μg',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 49,
		name: 'Resorcinol',
		reduction_percent: '99.1',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '1.79',
		tabacco_percent: '0.016',
		unit: 'μg',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 50,
		name: 'Selenium',
		reduction_percent: '79.5',
		percentage_text: 'more than',
		reduction_quantity: '21',
		cigarette_percent: '1.95',
		tabacco_percent: '0.4',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
	{
		id: 51,
		name: 'Styrene',
		reduction_percent: '98.3',
		reduction_quantity: '2',
		cigarette_percent: '15.4',
		tabacco_percent: '0.259',
		unit: 'μg',
	},
	{
		id: 52,
		name: 'Toluene',
		reduction_percent: '99.2',
		reduction_quantity: '1',
		cigarette_percent: '137',
		tabacco_percent: '1.08',
		unit: 'μg',
	},
	{
		id: 53,
		name: 'Vinyl chloride',
		reduction_percent: '99.4',
		percentage_text: 'more than',
		reduction_quantity: '1',
		cigarette_percent: '103',
		tabacco_percent: '0.657',
		unit: 'ng',
		less_than_tabacco: true,
		has_additional_info: true,
	},
];
